import { lagoon } from '@optum-lagoon/sdk';

export class LagoonSDK {
  constructor(namespace, env, schema) {
    this.namespace = namespace;
    this.env = env;
    this.schema = schema || {
      loadTables: true,
      loadForms: false,
    };
  }

  async init() {
    this.lagoon = lagoon;
    await lagoon.initialize(this.namespace, this.env, this.schema);
    return this.lagoon || true;
  }

  async getTable(tableName) {
    this[tableName] = this.lagoon.getTable(tableName);
    return this[tableName];
  }

  getRow(tableName, rowKey) {
    return this.lagoon.getTable(tableName).getRow(rowKey);
  }
}
